var map = {
	"./add-brown-circle.png": "./src/assets/icons/add-brown-circle.png",
	"./add-green-circle.png": "./src/assets/icons/add-green-circle.png",
	"./add-green-light-circle.svg": "./src/assets/icons/add-green-light-circle.svg",
	"./add-white-circle.png": "./src/assets/icons/add-white-circle.png",
	"./add-yellow-circle.png": "./src/assets/icons/add-yellow-circle.png",
	"./alert-menu-white.png": "./src/assets/icons/alert-menu-white.png",
	"./alert-menu.png": "./src/assets/icons/alert-menu.png",
	"./arrow-down-gray.png": "./src/assets/icons/arrow-down-gray.png",
	"./arrow-down-gray.svg": "./src/assets/icons/arrow-down-gray.svg",
	"./arrow-down-orange.svg": "./src/assets/icons/arrow-down-orange.svg",
	"./arrow-down-white.png": "./src/assets/icons/arrow-down-white.png",
	"./arrow-down.png": "./src/assets/icons/arrow-down.png",
	"./arrow-left-green-light.svg": "./src/assets/icons/arrow-left-green-light.svg",
	"./arrow-left-green.svg": "./src/assets/icons/arrow-left-green.svg",
	"./arrow-right-green-light.svg": "./src/assets/icons/arrow-right-green-light.svg",
	"./arrow-right-green.svg": "./src/assets/icons/arrow-right-green.svg",
	"./assistant.png": "./src/assets/icons/assistant.png",
	"./assistant.svg": "./src/assets/icons/assistant.svg",
	"./back-arrow-green.png": "./src/assets/icons/back-arrow-green.png",
	"./back-arrow-round-white.png": "./src/assets/icons/back-arrow-round-white.png",
	"./back-arrow-white.png": "./src/assets/icons/back-arrow-white.png",
	"./bg-planes-person.png": "./src/assets/icons/bg-planes-person.png",
	"./blog-white.png": "./src/assets/icons/blog-white.png",
	"./blog-white.svg": "./src/assets/icons/blog-white.svg",
	"./blog.png": "./src/assets/icons/blog.png",
	"./blog.svg": "./src/assets/icons/blog.svg",
	"./brown-edit-pencil.png": "./src/assets/icons/brown-edit-pencil.png",
	"./building-green.png": "./src/assets/icons/building-green.png",
	"./building-menu-white.png": "./src/assets/icons/building-menu-white.png",
	"./building-menu.png": "./src/assets/icons/building-menu.png",
	"./calendar-gray.png": "./src/assets/icons/calendar-gray.png",
	"./calendar-green-light.svg": "./src/assets/icons/calendar-green-light.svg",
	"./calendar-green.png": "./src/assets/icons/calendar-green.png",
	"./calendar-price-green.svg": "./src/assets/icons/calendar-price-green.svg",
	"./calendar-price-white.png": "./src/assets/icons/calendar-price-white.png",
	"./calendar-price-white.svg": "./src/assets/icons/calendar-price-white.svg",
	"./calendar-white.png": "./src/assets/icons/calendar-white.png",
	"./call-white.png": "./src/assets/icons/call-white.png",
	"./call-white.svg": "./src/assets/icons/call-white.svg",
	"./call.png": "./src/assets/icons/call.png",
	"./call.svg": "./src/assets/icons/call.svg",
	"./check-white-icon.png": "./src/assets/icons/check-white-icon.png",
	"./check.svg": "./src/assets/icons/check.svg",
	"./close-assistant.png": "./src/assets/icons/close-assistant.png",
	"./close-assistant.svg": "./src/assets/icons/close-assistant.svg",
	"./close-tooltip.png": "./src/assets/icons/close-tooltip.png",
	"./close-white.png": "./src/assets/icons/close-white.png",
	"./close-white.png.png": "./src/assets/icons/close-white.png.png",
	"./close.png": "./src/assets/icons/close.png",
	"./delete-document.png": "./src/assets/icons/delete-document.png",
	"./document-green-light.svg": "./src/assets/icons/document-green-light.svg",
	"./document-green.png": "./src/assets/icons/document-green.png",
	"./download-green.png": "./src/assets/icons/download-green.png",
	"./download-green.svg": "./src/assets/icons/download-green.svg",
	"./download-light-green.png": "./src/assets/icons/download-light-green.png",
	"./download-white.png": "./src/assets/icons/download-white.png",
	"./edit-profile.svg": "./src/assets/icons/edit-profile.svg",
	"./electronic-payroll-green.png": "./src/assets/icons/electronic-payroll-green.png",
	"./electronic-payroll-nav-gray.png": "./src/assets/icons/electronic-payroll-nav-gray.png",
	"./electronic-payroll-nav-green.png": "./src/assets/icons/electronic-payroll-nav-green.png",
	"./electronic-payroll-nav-white.png": "./src/assets/icons/electronic-payroll-nav-white.png",
	"./electronic-payroll-white.png": "./src/assets/icons/electronic-payroll-white.png",
	"./electronic-payroll-white.svg": "./src/assets/icons/electronic-payroll-white.svg",
	"./employees-green.png": "./src/assets/icons/employees-green.png",
	"./employees-nav-gray.png": "./src/assets/icons/employees-nav-gray.png",
	"./employees-nav-white.png": "./src/assets/icons/employees-nav-white.png",
	"./eye-gray.png": "./src/assets/icons/eye-gray.png",
	"./eye-gray.svg": "./src/assets/icons/eye-gray.svg",
	"./eye-green.png": "./src/assets/icons/eye-green.png",
	"./eye-light-green.png": "./src/assets/icons/eye-light-green.png",
	"./eye-light-green.svg": "./src/assets/icons/eye-light-green.svg",
	"./eye-orange.png": "./src/assets/icons/eye-orange.png",
	"./eye-orange.svg": "./src/assets/icons/eye-orange.svg",
	"./eye-red.png": "./src/assets/icons/eye-red.png",
	"./eye-red.svg": "./src/assets/icons/eye-red.svg",
	"./facebook.png": "./src/assets/icons/facebook.png",
	"./gray-edit-pencil.png": "./src/assets/icons/gray-edit-pencil.png",
	"./green-edit-pencil.png": "./src/assets/icons/green-edit-pencil.png",
	"./green-edit-pencil.svg": "./src/assets/icons/green-edit-pencil.svg",
	"./grey-edit-pencil.png": "./src/assets/icons/grey-edit-pencil.png",
	"./home-nav-gray.png": "./src/assets/icons/home-nav-gray.png",
	"./home-nav-green.png": "./src/assets/icons/home-nav-green.png",
	"./home-nav-white.png": "./src/assets/icons/home-nav-white.png",
	"./info.png": "./src/assets/icons/info.png",
	"./informative-green-light.png": "./src/assets/icons/informative-green-light.png",
	"./informative-green-light.svg": "./src/assets/icons/informative-green-light.svg",
	"./informative-green.svg": "./src/assets/icons/informative-green.svg",
	"./informative-white.svg": "./src/assets/icons/informative-white.svg",
	"./informative.svg": "./src/assets/icons/informative.svg",
	"./instagram.png": "./src/assets/icons/instagram.png",
	"./linkedin.png": "./src/assets/icons/linkedin.png",
	"./loader.gif": "./src/assets/icons/loader.gif",
	"./logout-menu-white.png": "./src/assets/icons/logout-menu-white.png",
	"./logout-menu.png": "./src/assets/icons/logout-menu.png",
	"./menu-responsive-green.png": "./src/assets/icons/menu-responsive-green.png",
	"./menu-responsive-green.svg": "./src/assets/icons/menu-responsive-green.svg",
	"./money-light-green.png": "./src/assets/icons/money-light-green.png",
	"./notification-menu-white.png": "./src/assets/icons/notification-menu-white.png",
	"./notification-menu.png": "./src/assets/icons/notification-menu.png",
	"./padlock.svg": "./src/assets/icons/padlock.svg",
	"./paper-up.png": "./src/assets/icons/paper-up.png",
	"./payment-gray.png": "./src/assets/icons/payment-gray.png",
	"./payment-green-light.png": "./src/assets/icons/payment-green-light.png",
	"./payroll-adjuster-green.png": "./src/assets/icons/payroll-adjuster-green.png",
	"./payroll-adjuster-nav-gray.png": "./src/assets/icons/payroll-adjuster-nav-gray.png",
	"./payroll-adjuster-nav-white.png": "./src/assets/icons/payroll-adjuster-nav-white.png",
	"./pila-light-green.png": "./src/assets/icons/pila-light-green.png",
	"./pointer-white.png": "./src/assets/icons/pointer-white.png",
	"./pointer-white.svg": "./src/assets/icons/pointer-white.svg",
	"./profile-gray.png": "./src/assets/icons/profile-gray.png",
	"./profile-green-light.png": "./src/assets/icons/profile-green-light.png",
	"./profile-green.png": "./src/assets/icons/profile-green.png",
	"./profile-white.png": "./src/assets/icons/profile-white.png",
	"./profile-white.svg": "./src/assets/icons/profile-white.svg",
	"./reports-green.png": "./src/assets/icons/reports-green.png",
	"./reports-nav-gray.png": "./src/assets/icons/reports-nav-gray.png",
	"./reports-nav-white.png": "./src/assets/icons/reports-nav-white.png",
	"./request-white.png": "./src/assets/icons/request-white.png",
	"./request-white.svg": "./src/assets/icons/request-white.svg",
	"./request.png": "./src/assets/icons/request.png",
	"./request.svg": "./src/assets/icons/request.svg",
	"./search-green.png": "./src/assets/icons/search-green.png",
	"./search-light-green.png": "./src/assets/icons/search-light-green.png",
	"./search-white.png": "./src/assets/icons/search-white.png",
	"./simple-search-green.png": "./src/assets/icons/simple-search-green.png",
	"./simple-search-green.svg": "./src/assets/icons/simple-search-green.svg",
	"./spinner-white.gif": "./src/assets/icons/spinner-white.gif",
	"./stack-nav-gray.png": "./src/assets/icons/stack-nav-gray.png",
	"./stack-nav-green.png": "./src/assets/icons/stack-nav-green.png",
	"./stack-nav-white.png": "./src/assets/icons/stack-nav-white.png",
	"./support-white.svg": "./src/assets/icons/support-white.svg",
	"./support.svg": "./src/assets/icons/support.svg",
	"./symbol-currency.png": "./src/assets/icons/symbol-currency.png",
	"./symbol-currency.svg": "./src/assets/icons/symbol-currency.svg",
	"./symbol-value-gray.png": "./src/assets/icons/symbol-value-gray.png",
	"./symbol-value-green.png": "./src/assets/icons/symbol-value-green.png",
	"./symbol-value-white.svg": "./src/assets/icons/symbol-value-white.svg",
	"./trash-brown.png": "./src/assets/icons/trash-brown.png",
	"./trash-white.png": "./src/assets/icons/trash-white.png",
	"./twitter.png": "./src/assets/icons/twitter.png",
	"./whatsapp-white.png": "./src/assets/icons/whatsapp-white.png",
	"./whatsapp-white.svg": "./src/assets/icons/whatsapp-white.svg",
	"./whatsapp.png": "./src/assets/icons/whatsapp.png",
	"./whatsapp.svg": "./src/assets/icons/whatsapp.svg",
	"./white-edit-pencil.png": "./src/assets/icons/white-edit-pencil.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\..*$";